import {
  IcreateCommercialAgentAPIBody,
  IgetCommercialAgentsAPIResponseAPIData,
} from 'api/endpoints/commercialAgent/commercialAgent.response.interface';
import * as CommercialAgentType from 'contexts/commercialAgent/reducer/commercialAgent.types';
import { IcommercialAgentState } from 'interfaces/commercialAgent.interface';

export type TcommercialAgentDispatchReducer =
  | {
      type: typeof CommercialAgentType.SET_COMMERCIAL_AGENTS;
      payload: Array<IgetCommercialAgentsAPIResponseAPIData>;
    }
  | {
      type: typeof CommercialAgentType.SET_IS_LOADING_GET_COMMERCIAL_AGENTS;
      payload: boolean;
    }
  | {
      type: typeof CommercialAgentType.SET_IS_LOADING_CREATE_UPDATE_COMMERCIAL_AGENT;
      payload: boolean;
    }
  | {
      type: typeof CommercialAgentType.SET_UPDATED_COMMERCIAL_AGENT;
      payload: {
        agentId: string;
        agent: Partial<IcreateCommercialAgentAPIBody>;
      };
    }
  | {
      type: typeof CommercialAgentType.SET_AGENT_SELECTED;
      payload: IgetCommercialAgentsAPIResponseAPIData | null;
    }
  | {
      type: typeof CommercialAgentType.DELETE_COMMERCIAL_AGENT;
      payload: string;
    }
  | {
      type: typeof CommercialAgentType.SET_IS_LOADING_DELETE_COMMERCIAL_AGENT;
      payload: {
        isLoading: boolean;
        agentId: string | null;
      };
    }
  | {
      type: typeof CommercialAgentType.SET_IS_LOADING_ASSIGN_AGENTS_TO_CLIENT;
      payload: boolean;
    };

export default function commercialAgentReducer(
  state: IcommercialAgentState,
  action: TcommercialAgentDispatchReducer
) {
  const { type, payload } = action;

  switch (type) {
    case CommercialAgentType.SET_COMMERCIAL_AGENTS: {
      const setCommercialAgents: IcommercialAgentState = {
        ...state,
        agents: payload,
      };
      return setCommercialAgents;
    }

    case CommercialAgentType.SET_IS_LOADING_GET_COMMERCIAL_AGENTS: {
      const setIsLoadingGetCommercialAgents: IcommercialAgentState = {
        ...state,
        isLoadingGetCommercialAgents: payload,
      };
      return setIsLoadingGetCommercialAgents;
    }

    case CommercialAgentType.SET_IS_LOADING_CREATE_UPDATE_COMMERCIAL_AGENT: {
      const setIsLoadingCreateCommercialAgent: IcommercialAgentState = {
        ...state,
        isLoadingCreateUpdateCommercialAgent: payload,
      };
      return setIsLoadingCreateCommercialAgent;
    }

    case CommercialAgentType.SET_UPDATED_COMMERCIAL_AGENT: {
      const setUpdatedCommercialAgent: IcommercialAgentState = {
        ...state,
        agents: state.agents.map((agent) =>
          agent.id === payload.agentId ? { ...agent, ...payload.agent } : agent
        ),
      };
      return setUpdatedCommercialAgent;
    }

    case CommercialAgentType.SET_AGENT_SELECTED: {
      const setAgentSelected: IcommercialAgentState = {
        ...state,
        agentSelected: payload,
      };
      return setAgentSelected;
    }

    case CommercialAgentType.DELETE_COMMERCIAL_AGENT: {
      const deleteCommercialAgent: IcommercialAgentState = {
        ...state,
        agents: state.agents.filter((agent) => agent.id !== payload),
      };
      return deleteCommercialAgent;
    }

    case CommercialAgentType.SET_IS_LOADING_DELETE_COMMERCIAL_AGENT: {
      const setIsLoadingDeleteCommercialAgent: IcommercialAgentState = {
        ...state,
        isLoadingDeleteCommercialAgent: {
          isLoading: payload.isLoading,
          agentId: payload.agentId,
        },
      };
      return setIsLoadingDeleteCommercialAgent;
    }

    case CommercialAgentType.SET_IS_LOADING_ASSIGN_AGENTS_TO_CLIENT: {
      const setIsLoadingAssignAgentsToClient: IcommercialAgentState = {
        ...state,
        isLoadingAssignAgentsToClient: payload,
      };
      return setIsLoadingAssignAgentsToClient;
    }

    default:
      return state;
  }
}
